module.exports = __webpack_public_path__ + "static/img/200041.8aa8e729.png";